import { TablePageChangeEvent } from '@servicetitan/design-system';
import { createContext, useContext } from 'react';

type OutboundCallerIdTableContextType = {
  table: {
    data: any[];
    totalCount: number;
    page: any;
    onPageChange: (e: TablePageChangeEvent) => void;
    pageSizes: number[];
    selectedItem: any;
    onSelectionChange: (event: any) => void;
  };
  filters: {
    value: string | null;
    onValueChange: (value: string | null) => void;
    areaCodes: string[];
    onAreaCodesChange: (areaCodes: string[]) => void;
    namedFilter: string;
    onNamedFilterChange: (namedFilter: string) => void;
    hasFilters: () => boolean;
    onClear: () => void;
  };
  areaCodesOptions: string[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
  tenantName: string;
};

export const OutboundCallerIdTableContext = createContext<
  OutboundCallerIdTableContextType | undefined
>(undefined);

export const useOutboundCallerIdTableContext =
  (): OutboundCallerIdTableContextType => {
    const context = useContext(OutboundCallerIdTableContext);
    if (!context) {
      throw new Error(
        'useOutboundCallerIdTableContext must be used within an OutboundCallerIdTableProvider',
      );
    }
    return context;
  };
